import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await auth.login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr("Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="min-h-[80vh] grid place-items-center bg-offwhite py-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 rounded-lg border border-[var(--border-soft)] shadow-md">
        <div className="flex items-center gap-2 mb-6 text-navy">
          <div className="h-10 w-10 rounded-md bg-navy grid place-items-center text-white"><Lock size={18} /></div>
          <h1 className="font-display text-2xl">Admin Login</h1>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-navy-800 mb-1">Email</label>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full h-12 px-3 border-2 border-[var(--border-soft)] rounded-md focus:border-money focus:outline-none" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-navy-800 mb-1">Password</label>
            <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full h-12 px-3 border-2 border-[var(--border-soft)] rounded-md focus:border-money focus:outline-none" data-testid="admin-password-input" />
          </div>
          {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} className="w-full h-12 bg-money text-white font-bold rounded-md disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </section>
  );
}
